<!-- Header section -->
<login-header></login-header>

<!-- How it works hero -->
<div class="howit_works_hero gradient_bg" style="background-image: url('/assets/images/contact-bg.webp');">
    <div class="px-90 m-auto text-center">
        <div class="howitworks_hero_image">
            <img src="/assets/images/how-it-works-hero.webp" alt="" class="w-100">
        </div>
    </div>
</div>

<!-- FC features section -->
<div class="about_features">
    <div class="aboutfeature_main px-90 m-auto">
        <div class="aboutfeature_title text-center mb-lg-5 mb-3">
            <p class="lp_p">Our App</p>
            <h2 class="lp_h2">One Simple, Secure Personal Application</h2>
        </div>

        <div class="aboutfeature_section">

            <div class="mobile-img d-block d-lg-none">
                <div class="mobileapp-img">
                    <img src="/assets/images/secure-personal-application.webp" alt="mobile app" loading="lazy">
                </div>
            </div>

            <div class="feature-section-one">
                <div class="aboutsingle_feature">
                    <div class="aboutfeature-img">
                        <img src="/assets/images/ab-legacy-yellow.svg" width="40" height="40" alt="legacy" loading="lazy">
                    </div>
                    <div class="aboutfeature-text">
                        <p class="mb-0 lp_p">Create videos as your legacy communication to those you love.</p>
                    </div>
                </div>
                <div class="aboutsingle_feature">
                    <div class="aboutfeature-img">
                        <img src="/assets/images/ab-call-red.svg" width="40" height="40" alt="call" loading="lazy">
                    </div>
                    <div class="aboutfeature-text">
                        <p class="mb-0 lp_p">Call 911 in 560 cities globally, and your family, at the same time.</p>
                    </div>
                </div>
                <div class="aboutsingle_feature">
                    <div class="aboutfeature-img">
                        <img src="/assets/images/ab-gps.svg" width="40" height="40" alt="gps" loading="lazy">
                    </div>
                    <div class="aboutfeature-text">
                        <p class="mb-0 lp_p">Global GPS at your fingertips for emergencies or family connectivity.</p>
                    </div>
                </div>
                <div class="aboutsingle_feature">
                    <div class="aboutfeature-img">
                        <img src="/assets/images/ab-chat.svg" width="40" height="40" alt="chat" loading="lazy">
                    </div>
                    <div class="aboutfeature-text">
                        <p class="mb-0 lp_p">Live Customer Care and Concierge Support.</p>
                    </div>
                </div>
            </div>

            <div class="mobile-img d-none d-lg-block">
                <div class="mobileapp-img">
                    <img src="/assets/images/secure-personal-application.webp" alt="mobile app" class="d-none d-md-block">
                </div>
            </div>

            <div class="feature-section-two">
                <div class="aboutsingle_feature">
                    <div class="aboutfeature-img vault">
                        <img src="/assets/images/ab-vault.svg" width="40" height="40" alt="vault" loading="lazy">
                    </div>
                    <div class="aboutfeature-text">
                        <p class="mb-0 lp_p">Individual secure storage vault for each family member to store private documents and information.</p>
                    </div>
                </div>
                <div class="aboutsingle_feature">
                    <div class="aboutfeature-img">
                        <img src="/assets/images/ab-files.svg" width="40" height="40" alt="files" loading="lazy">
                    </div>
                    <div class="aboutfeature-text">
                        <p class="mb-0 lp_p">File-sharing so the whole family has easy access.</p>
                    </div>
                </div>
                <div class="aboutsingle_feature">
                    <div class="aboutfeature-img">
                        <img src="/assets/images/ab-photo.svg" width="40" height="40" alt="photo" loading="lazy">
                    </div>
                    <div class="aboutfeature-text">
                        <p class="mb-0 lp_p">Archive your family photos for generations to come.</p>
                    </div>
                </div>
                <div class="aboutsingle_feature">
                    <div class="aboutfeature-img">
                        <img src="/assets/images/ab-caendar.svg" width="40" height="40" alt="calendar" loading="lazy">
                    </div>
                    <div class="aboutfeature-text">
                        <p class="mb-0 lp_p">Private calendars and reminders.</p>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>

<!-- Why Family Central  -->
<div class="why_familycentral gradient_bg" style="background-image: url('/assets/images/homehero-bg.webp');">
    <div class="px-90 m-auto">
        
        <div class="why_familycentral_top">
            <div class="why_familycentral_content d-md-grid">
                <div class="why_familycentral_img mb-4 mb-md-0">
                    <img src="/assets/images/mom-and-baby-playing-with-ipad.png" alt="" loading="lazy">
                </div>
                <div class="why_familycentral_text">
                    <h2 class="lp_h2">Why Family Central</h2>
                    <p class="lp_p mb-0">We created Family Central as a safe haven for families to securely store their most valuable information today and for generations to come. And you don’t have to do it all alone. Your family's trusted professional advisers — such as financial planners, lawyers or doctors — can securely share documents with you as well.</p>
                </div>
            </div>
        </div>

        <div class="why_familycentral_list text-center d-md-grid">
            <div class="why_single">
                <img src="/assets/images/why-planning.png" width="95" height="194" alt="" loading="lazy">
                <h3 class="h3">Planning</h3>
                <p class="lp_p mb-0">Family Central gives you tools to plan your day-to-day so that you can focus on the important things.</p>
            </div>
            <div class="why_single">
                <img src="/assets/images/why-legacy.png" width="98" height="194" alt="" loading="lazy">
                <h3 class="h3">Legacy</h3>
                <p class="lp_p mb-0">Create and protect your legacy and leave your loved ones with lasting messages and communications.</p>
            </div>
            <div class="why_single">
                <img src="/assets/images/peace-of-mind.png" width="97" height="194" alt="" loading="lazy">
                <h3 class="h3">Peace of Mind</h3>
                <p class="lp_p mb-0">All your important documents easily accessible in one place, securely stored.</p>
            </div>
        </div>
        
    </div>
</div>

<div class="howit_works_carousel">
    <div class="px-90 m-auto">
        <div class="carousel_content d-lg-grid align-items-center">
            <app-circular-carousel></app-circular-carousel>
            <app-get-started-box></app-get-started-box>
        </div>
    </div>
</div>

<app-footer></app-footer>